import { toast } from 'react-toastify/unstyled';

import { ToastCloseButton, ToastMsg } from './ToastMsg.tsx';

const TOAST_ID = 'new-version';

// "Not now" keeps the prompt away until the next release. The close button only hides it until
// the next check.
let snoozedBuildTs: number | null = null;
// An open toast stays as shown when a later build deploys, so "Not now" reads the latest one here.
let latestBuildTs: number | null = null;

export function showNewVersionToast(deployedBuildTs: number) {
    latestBuildTs = deployedBuildTs;
    if (deployedBuildTs === snoozedBuildTs || toast.isActive(TOAST_ID)) return;

    toast(
        <ToastMsg variant="warning" title="New version available">
            <p>Reload the page to get the latest version.</p>
            {/* The shadcn Button would pull radix into the entry chunk, since main.tsx imports
                this module statically. Both buttons copy its sm size, and Reload also copies
                its default variant. */}
            <div className="mt-2 flex gap-2">
                <button
                    type="button"
                    className={`${BUTTON_CLASSES} bg-primary/90 text-primary-foreground shadow-sm hover:bg-primary`}
                    onClick={() => window.location.reload()}
                >
                    Reload
                </button>
                <button
                    type="button"
                    className={`${BUTTON_CLASSES} border border-warning/40 hover:bg-warning/15`}
                    onClick={() => {
                        snoozedBuildTs = latestBuildTs;
                        toast.dismiss(TOAST_ID);
                    }}
                >
                    Not now
                </button>
            </div>
        </ToastMsg>,
        {
            toastId: TOAST_ID,
            autoClose: false,
            closeOnClick: false,
            closeButton: <ToastCloseButton />,
        }
    );
}

const BUTTON_CLASSES =
    'inline-flex h-8 items-center justify-center rounded-lg px-3 text-xs font-medium whitespace-nowrap transition-colors focus-visible:outline-hidden focus-visible:ring-1 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background';
